<template>
    <div class="block-editor send-email">
        <div class="wrapper">
            <div class="title">{{ $t("chatbotv2.createEventStartTitle") }}</div>
            <div class="text-editor-wrapper date">
                <a-radio-group v-model:value="clone.selectType" class="radio-btns">
                    <a-radio value="now" class="radio-btn">{{ $t("chatbotv2.createEventNow") }}</a-radio>
                    <a-radio value="after" class="radio-btn" style="margin: 10px 0">
                        <input
                            type="number"
                            v-model="afterSelectTimeValue"
                            class="input-number"
                            :disabled="clone.selectType !== 'after'"
                        />
                        <a-select
                            style="width: 170px"
                            v-model="afterSelectTime"
                            show-search
                            @change="changeRepeat"
                            :disabled="clone.selectType !== 'after'"
                        >
                            <a-select-option
                                v-for="(repeatTime, index) of timeOptions"
                                :key="index"
                                :value="repeatTime.value"
                            >
                                {{ repeatTime.label }}
                            </a-select-option>
                        </a-select>
                        <div class="name">{{ $t("chatbotv2.createEventAfter") }}</div>
                        <a-select
                            style="width: 200px"
                            v-model="afterSelectDate"
                            show-search
                            @change="changeRepeat"
                            :disabled="clone.selectType !== 'after'"
                        >
                            <a-select-option
                                v-for="(repeatTime, index) of dateOptions"
                                :key="index"
                                :value="repeatTime.value"
                            >
                                {{ repeatTime.label }}
                            </a-select-option>
                        </a-select>
                    </a-radio>
                    <a-radio value="before" class="radio-btn">
                        <input
                            type="number"
                            v-model="beforeSelectTimeValue"
                            class="input-number"
                            :disabled="clone.selectType !== 'before'"
                        />
                        <a-select
                            style="width: 170px"
                            v-model="beforeSelectTime"
                            show-search
                            @change="changeRepeat"
                            :disabled="clone.selectType !== 'before'"
                        >
                            <a-select-option
                                v-for="(repeatTime, index) of timeOptions"
                                :key="index"
                                :value="repeatTime.value"
                            >
                                {{ repeatTime.label }}
                            </a-select-option>
                        </a-select>
                        <div class="name">{{ $t("chatbotv2.createEventBefore") }}</div>
                        <a-select
                            style="width: 200px"
                            v-model="beforeSelectDate"
                            show-search
                            @change="changeRepeat"
                            :disabled="clone.selectType !== 'before'"
                        >
                            <a-select-option
                                v-for="(repeatTime, index) of dateOptions"
                                :key="index"
                                :value="repeatTime.value"
                            >
                                {{ repeatTime.label }}
                            </a-select-option>
                        </a-select>
                    </a-radio>
                </a-radio-group>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">{{ $t("chatbotv2.createEventDurationTitle") }}</div>
            <div>
                <input type="number" v-model="clone.eventTime" class="input-number" />
                <a-select style="width: 170px" v-model="clone.eventTimeType" show-search @change="changeRepeat">
                    <a-select-option v-for="(repeatTime, index) of timeOptions" :key="index" :value="repeatTime.value">
                        {{ repeatTime.label }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">{{ $t("chatbotv2.createEventSummaryTitle") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    :placeholder="$t('chatbotv2.createEventSummaryPlaceholder')"
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.summary"
                />
            </div>
        </div>
        <div class="wrapper">
            <div class="title">{{ $t("chatbotv2.createEventDescriptionTitle") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    :placeholder="$t('chatbotv2.createEventDescriptionPlaceholder')"
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.description"
                />
            </div>
        </div>
        <div class="wrapper">
            <div class="title">{{ $t("chatbotv2.createEventAgentsTitle") }}</div>
            <a-select v-model="clone.selectedUser" show-search style="width: 100%">
                <a-select-option v-for="(user, index) of users" :key="index" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
        </div>
        <div class="wrapper">
            <div class="title">{{ $t("chatbotv2.createEventCalendarsTitle") }}</div>
            <a-select v-model="clone.selectUserCalendar" show-search style="width: 100%">
                <a-select-option v-for="(user, index) of userCalendars" :key="index" :value="user._id">
                    {{ user.summary }}
                </a-select-option>
            </a-select>
        </div>
        <div class="wrapper">
            <div class="title">{{ $t("chatbotv2.createEventOtherAgentsTitle") }}</div>
            <a-select v-model="clone.refUsers" show-search style="width: 100%" mode="tags">
                <a-select-option v-for="(user, index) of users" :key="index" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapActions, mapState } from "vuex";

const log = log2("CreateEvent");
export default {
    name: "CreateEvent",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            selectType: "now",
            afterSelectTime: "minutes",
            afterSelectDate: "now_date",
            afterSelectTimeValue: 10,
            beforeSelectTime: "minutes",
            beforeSelectDate: "now_date",
            beforeSelectTimeValue: 10,
            userCalendars: [],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
        timeOptions() {
            return [
                { label: this.$t("chatbotv2.createEventUnitDays"), value: "days" },
                { label: this.$t("chatbotv2.createEventUnitHours"), value: "hours" },
                { label: this.$t("chatbotv2.createEventUnitMinutes"), value: "minutes" },
            ];
        },
        dateOptions() {
            return [
                { label: this.$t("chatbotv2.createEventDateNow"), value: "now_date" },
                { label: this.$t("chatbotv2.createEventDateChatStart"), value: "chat_date" },
            ];
        },
    },
    methods: {
        ...mapActions({
            getUserCalendars: "calendar/getUserCalendars",
        }),
        changeRepeat(val) {
            this.customRepeatModal = val === "custom";
        },
    },
    mounted() {
        console.log("create event this.clone", this.clone);
        this.clone.eventTime = this.clone.eventTime || 10;
        this.clone.eventTimeType = this.clone.eventTimeType || "minutes";
        if (this.clone.selectType === "after") {
            this.afterSelectTimeValue = this.clone.timeNumber;
            this.afterSelectTime = this.clone.timeType;
            this.afterSelectDate = this.clone.dateType;
        } else if (this.clone.selectType === "before") {
            this.beforeSelectTimeValue = this.clone.timeNumber;
            this.beforeSelectTime = this.clone.timeType;
            this.beforeSelectDate = this.clone.dateType;
        }
        console.log("this.clone.selectedUser", this.clone.selectedUser);
        if (this.clone.selectedUser !== "") {
            this.getUserCalendars(this.clone.selectedUser).then((res) => {
                this.userCalendars = res;
            });
        }
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        async "clone.selectedUser"(val) {
            this.clone.selectUserCalendar = null;
            console.log("clone.selectedUser", val);
            if (this.clone.selectedUser === "") return;
            this.getUserCalendars(val).then((res) => {
                this.userCalendars = res;
            });
        },
        afterSelectTimeValue(val) {
            this.clone["timeNumber"] = val;
        },
        beforeSelectTimeValue(val) {
            this.clone["timeNumber"] = val;
        },
        afterSelectTime(val) {
            this.clone["timeType"] = val;
        },
        beforeSelectTime(val) {
            this.clone["timeType"] = val;
        },
        afterSelectDate(val) {
            this.clone["dateType"] = val;
        },
        beforeSelectDate(val) {
            this.clone["dateType"] = val;
        },
    },
};
</script>

<style lang="scss">
.input-number {
    border: 0.5px solid grey;
    border-radius: 10px;
    height: 30px;
    width: 50px;
    margin-right: 10px;
}

.block-editor.send-email {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .radio-btns {
        display: flex;
        flex-direction: column;

        .name {
            font-weight: 700;
            margin: 0 10px;
        }

        .radio-btn {
            display: flex;
            align-items: center;
        }
    }

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &.date {
                padding: 10px;
            }

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .ant-select {
            width: 100%;
        }
    }
}
</style>
